import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/SolutionsAgenticAiPlatformPage.head';
import { SolutionsAgenticAiPlatformPage } from '@pages/SolutionsAgenticAiPlatformPage';

export const Route = createFileRoute('/solutions/agentic-ai-platform')({
  component: SolutionsAgenticAiPlatformPage,
  head: () => head,
});
